import routes from 'config/route';
import M from 'messages';

export const gettingStartedSteps = [
  {
    stepNumber: 1,
    icon: 'person',
    title: M.get('welcome.gettingStarted.steps.personalizeProfile.title'),
    description: M.get('welcome.gettingStarted.steps.personalizeProfile.description'),
    getRoute: currentUser => routes.serviceProviderEdit.path.replace(':id', currentUser?.serviceProviderId),
  },
  {
    stepNumber: 2,
    icon: 'wine_bar',
    title: M.get('welcome.gettingStarted.steps.addWines.title'),
    description: M.get('welcome.gettingStarted.steps.addWines.description'),
    getRoute: () => routes.wines.path,
  },
  {
    stepNumber: 3,
    icon: 'checklist',
    title: M.get('welcome.gettingStarted.steps.createList.title'),
    description: M.get('welcome.gettingStarted.steps.createList.description'),
    getRoute: () => routes.wineLists.path,
  },
  {
    stepNumber: 4,
    icon: 'earthquake',
    title: M.get('welcome.gettingStarted.steps.checkAnalytics.title'),
    description: M.get('welcome.gettingStarted.steps.checkAnalytics.description'),
    getRoute: () => routes.wineLoversActivities.path,
    isPaid: true,
  },
  {
    stepNumber: 5,
    icon: 'campaign',
    title: M.get('welcome.gettingStarted.steps.createCampaign.title'),
    description: M.get('welcome.gettingStarted.steps.createCampaign.description'),
    getRoute: () => routes.campaigns.path,
    isPaid: true,
  },
];
